<script>
    import { onMount } from 'svelte';
    import { Router, Route, navigate } from 'svelte-routing';
    import Writer from '../components/WriterComponent/index.svelte';
    import NotesList from '../components/NotesList.svelte';
    import { notesMock } from '../mocks/Mocks.svelte';
    import feedStore from '../stores/feed';
    // import * as entityStorage from '../stores/entities'
    import * as storeHelpers from '../stores/helpers';

    let notes = [];

    function getNotes() {
        fetch(`/api/v1/posts`)
        .then(data => {
            return data.json()
        })
        .then(response => {
            const { posts, status } = response;
            if (status === 401) {
                storeHelpers.clearAuth();
                navigate('/login');
                return;
            }
            notes = posts

            processNotesResponse();
        });
    }

    function findHashtags(noteContent) {
        const rule = /\B(\#[a-zA-Z0-9]{3,}\b)/g;  // Regex for the complete token, anchor to string start
        // const matches = rule.exec(noteContent);
        const matches = noteContent.match(rule);
        return matches || [];
    }

    function processNotesResponse() {
        const itemNotesMap = notes.reduce((acc, note) => {
            // find hashtags in notes and those are the keys of map
            const hashtags = findHashtags(storeHelpers.stringifyNoteContent(note.content));

            hashtags.forEach(hashtag => {
                if (hashtag in acc.map) {
                    acc.map[hashtag].push(`0:0:n${note.id}`)
                } else {
                    acc.map[hashtag] = [`0:0:n${note.id}`]
                }
            });

            const key = `n${note.id}`;
            acc.notesDict[key] = note;
            acc.notesDict[note.uuid] = key;
            return acc;
        }, {
            map: {},
            notesDict: {}
        });

        feedStore.addTaggedNoteEntities(itemNotesMap);
    }

    function getMockedNotes() {
        ({ posts: notes } = notesMock);

        processNotesResponse();
    }

    function navigateToNote(content) {
        navigate(content.noteLink, { replace: true, state: { hh: 'androiddd'} })
    }

    onMount(() => {
        getNotes();
        // console.log('mock get notes')
        // getMockedNotes();
    });

</script>

<Router>
    <Route path="">
        <NotesList notes={notes} />
    </Route>
    <Route path="/:postUid" let:params>
        <Writer
            postUid="{params.postUid}"
            navigateToNote={navigateToNote}    
        />
    </Route>
</Router>